var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwaplblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.363,
    height: 67.07,
    viewBox: "0 0 84.363 67.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(3.535 3.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M0,.94V48.8S.4,60,14.211,60s13.94-11.2,13.94-11.2L28.02,13.2S28.815,0,41.979,0,55.946,13.2,55.946,13.2V56.526",
    transform: "translate(10.673 0.001)",
    fill: "none",
    stroke: "#39beec",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M15.093,15.093V0H0",
    transform: "translate(77.293 49.328) rotate(135)",
    fill: "none",
    stroke: "#39beec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M15.095,0V15.094H0",
    transform: "translate(10.673 21.347) rotate(-135)",
    fill: "none",
    stroke: "#39beec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwaplblue);
export default __webpack_public_path__ + "static/media/Swaplblue.4a9a8118e203c7e933080d7bb30bf183.svg";
export { ForwardRef as ReactComponent };